import { useCallback, useEffect, useRef, useState } from 'react';
import api from '../lib/api';

export const useTillScanner = (saleRef) => {
  const [session, setSession] = useState(null), [error, setError] = useState('');
  const [tillId] = useState(() => { let id = sessionStorage.getItem('pos-scanner-till'); if (!id) { id = crypto.randomUUID(); sessionStorage.setItem('pos-scanner-till', id); } return id; });
  const ref = useRef(null); ref.current = session;
  const refresh = useCallback(async () => {
    const s = ref.current;
    if (!s) return;
    try {
      if (!['ended','completed','checking_out'].includes(s.state)) await api.post(`/scan-pos/sessions/${s.session_id}/action`, { action: 'heartbeat' });
      const { data } = await api.get(`/scan-pos/sessions/${s.session_id}`);
      if (ref.current?.session_id === s.session_id) { setSession(data); setError(''); }
    } catch { setError('Connection interrupted. Pending phone content has not been confirmed.'); }
  }, []);
  useEffect(() => { const t = setInterval(refresh, 2000); return () => clearInterval(t); }, [refresh]);
  useEffect(() => {
    const s = ref.current;
    if (s && s.sale_ref !== saleRef) {
      api.post(`/scan-pos/sessions/${s.session_id}/action`, { action: 'end', reason: 'Active sale changed or was held' }).catch(() => {});
      ref.current = null; setSession(null);
    }
  }, [saleRef]);
  const enable = async name => { const { data } = await api.post('/scan-pos/tills', { till_id: tillId, sale_ref: saleRef, name }); ref.current = data; setSession(data); await refresh(); };
  const action = async (action, reason = '') => { await api.post(`/scan-pos/sessions/${session.session_id}/action`, { action, reason }); await refresh(); };
  const decide = async (eid, values) => { const { data } = await api.post(`/scan-pos/sessions/${session.session_id}/events/${eid}`, values); await refresh(); return data; };
  const blocked = !!session && session.state !== 'ended' && (session.state !== 'finished' || (session.events || []).some(e => !['applied','dismissed','superseded'].includes(e.status)));
  return { session, error, enable, action, decide, refresh, blocked };
};